<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col lg="8" md="8" sm="12" xs="12">
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col>
                  <p class="subtitle-1 font-weight-bold">
                    Complaint Types
                  </p>
                </v-col>
                <v-col>
                  <span class="float-right">
                    <v-btn
                      :color="getColorScheme.darkColor"
                      small
                      dark
                      raised
                      @click="dialog = true"
                    >
                      <v-icon class="mr-1" small>
                        mdi-plus
                      </v-icon>
                      Complaint Type
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-data-table
                    :headers="headers"
                    :items="complaintCategoryTypes"
                    class="elevation-1"
                    dense
                  >
                    <template v-slot:[`item.category`]="{ item }">
                      <span class="caption">
                        {{ item.category.category }}
                      </span>
                    </template>
                    <template v-slot:[`item.type`]="{ item }">
                      <span class="caption">{{ item.type.type }}</span>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-row no-gutters align="center">
                        <v-col align="center">
                          <v-btn icon>
                            <v-icon
                              color="teal"
                              small
                              @click.native="editRecord($event, item)"
                            >
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                          <v-btn icon>
                            <v-icon
                              color="pink"
                              small
                              @click.native="
                                confirmDeleteRecord($event, item.type.id)
                              "
                              >mdi-delete
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" persistent width="40vh">
      <v-card>
        <v-card-title
          v-if="isEdit"
          class="title white--text"
          :style="`background-color:${getColorScheme.darkColor};`"
          >Edit Complaint Type
        </v-card-title>
        <v-card-title
          v-else
          class="title white--text"
          :style="`background-color:${getColorScheme.darkColor};`"
          >New Complaint Type
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-row no-gutters v-if="errors.length">
              <v-col>
                <strong>Please correct the following error(s):</strong>
                <ul class="red--text">
                  <li v-for="(error, i) in errors" :key="i">{{ error }}</li>
                </ul>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col class="pt-6">
                <v-combobox
                  v-model="complaintType.category"
                  :items="getComplaintCategories"
                  item-text="category"
                  label="Complaint Category"
                  outlined
                  dense
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-text-field
                  v-model="complaintType.type"
                  label="Complaint Type"
                  dense
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-grey" small raised dark @click="cancel"
                    >Cancel
                  </v-btn>
                  <v-btn
                    v-if="isEdit"
                    :color="getColorScheme.darkColor"
                    small
                    raised
                    dark
                    @click="editRecordSave"
                    >Save
                  </v-btn>
                  <v-btn
                    v-else
                    :color="getColorScheme.darkColor"
                    small
                    raised
                    dark
                    @click="saveRecord"
                    >Submit
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteConfirm" persistent max-width="425">
      <v-card>
        <v-card-title class="headline">Delete Complaint Type?</v-card-title>
        <v-card-text>
          Are you sure you want to delete this complaint type?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue-grey"
            dark
            small
            raised
            @click="dialogDeleteConfirm = false"
            >Cancel
          </v-btn>
          <v-btn
            :color="getColorScheme.darkColor"
            dark
            small
            raised
            @click="deleteRecord"
            >Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "complaint-types",
  data() {
    return {
      complaintCategoryTypes: [],
      complaintType: {},
      dialog: false,
      dialogDeleteConfirm: false,
      deleteId: null,
      isEdit: false,
      errors: [],
      headers: [
        {
          text: "Complaint Category",
          value: "category",
          width: "25%",
          class: "grey darken-3 white--text",
          mobile: true,
        },
        {
          text: "Complaint Type",
          value: "type",
          width: "50%",
          class: "grey darken-3 white--text",
          mobile: true,
        },
        {
          text: "Action(s)",
          value: "action",
          width: "25%",
          align: "center",
          class: "grey darken-3 white--text",
          mobile: true,
        },
      ],
    };
  },
  async created() {
    await this.getComplaintCategoriesAction();
    this.loadComplaintCategories();
    this.resetFields();
  },
  computed: {
    ...mapGetters(["getComplaintCategories", "getColorScheme"]),
  },
  methods: {
    ...mapActions([
      "getComplaintCategoriesAction",
      "addComplaintTypeAction",
      "editComplaintTypeAction",
      "deleteComplaintTypeAction",
    ]),
    loadComplaintCategories() {
      this.complaintCategoryTypes = [];
      for (const category of this.getComplaintCategories) {
        for (const type of category.types) {
          this.complaintCategoryTypes.push({
            category: category,
            type: type,
          });
        }
      }
    },
    editRecord(e, selectedObj) {
      e.stopPropagation();
      this.isEdit = true;
      this.dialog = true;
      this.complaintType = {
        category: selectedObj.category.category,
        type: selectedObj.type.type,
        typeId: selectedObj.type.id,
      };
    },
    async editRecordSave() {
      if (!this.isFormValid()) {
        return;
      }
      await this.editComplaintTypeAction({
        id: this.complaintType.typeId,
        type: this.complaintType.type,
      });
      this.loadComplaintCategories();
      this.dialog = false;
      this.isEdit = false;
      this.resetFields();
    },
    confirmDeleteRecord: function(e, deleteComplaintTypeId) {
      e.stopPropagation();
      this.dialogDeleteConfirm = true;
      this.deleteId = deleteComplaintTypeId;
    },
    async deleteRecord() {
      await this.deleteComplaintTypeAction(this.deleteId);
      this.loadComplaintCategories();
      this.dialogDeleteConfirm = false;
    },
    cancel() {
      this.dialog = false;
      this.isEdit = false;
      this.resetFields();
    },
    async saveRecord() {
      if (!this.isFormValid()) {
        return;
      }
      await this.addComplaintTypeAction({
        categoryId: this.complaintType.category.id,
        type: this.complaintType.type,
      });
      this.loadComplaintCategories();
      this.dialog = false;
      this.resetFields();
    },
    isFormValid() {
      let isValid = true;
      this.errors = [];
      if (this.complaintType.category === "") {
        this.errors.push("Complaint Category is required.");
      }
      if (
        this.complaintType.type === "" ||
        this.complaintType.type.trim() === ""
      ) {
        this.errors.push("Complaint Type is required.");
      }

      if (this.errors.length > 0) {
        isValid = false;
      }
      return isValid;
    },
    resetFields() {
      this.complaintType = {
        category: "",
        type: "",
      };
      this.errors = [];
    },
  },
};
</script>
